/**
 * @generated SignedSource<<9903f66dbbb82410b3975cdd654600f9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type commentSummary_nativeIssueTable_CommentSummaryCell$data = {
  readonly commentSummary: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "commentSummary_nativeIssueTable_CommentSummaryCell";
};
export type commentSummary_nativeIssueTable_CommentSummaryCell$key = {
  readonly " $data"?: commentSummary_nativeIssueTable_CommentSummaryCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"commentSummary_nativeIssueTable_CommentSummaryCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "commentSummary_nativeIssueTable_CommentSummaryCell",
  "selections": [
    {
      "concreteType": "JiraCommentSummary",
      "kind": "LinkedField",
      "name": "commentSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "totalCount"
        }
      ]
    }
  ],
  "type": "JiraCommentSummaryField"
};

(node as any).hash = "1bfa4193d7f59454aef08d055f599510";

export default node;
